import {
    historyScopeAtom,
    isChangingAtom,
    stampCardSorterAtom,
} from '@activities/membership/stamp/StampsActivity/atoms/stampAtoms';
import stampQueries from '@apis/queries/stampQueries';
import { useQuery } from '@tanstack/react-query';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';

function useSelectScope() {
    const sorter = useAtomValue(stampCardSorterAtom);
    const [scope, setScope] = useAtom(historyScopeAtom);
    const { data } = useQuery(stampQueries.cardList(sorter));
    const setIsChanging = useSetAtom(isChangingAtom);
    const items = data?.cards?.map((it) => ({
        name: it.shopName || it.shopGroupName,
        value: it.shopId || it.shopGroupId,
        targetScope: it.targetScope,
    }));
    const isSelected = (item: NonNullable<typeof items>[number]) => {
        if (scope?.targetScope === 'SHOP') {
            return scope?.shopId === item.value;
        }
        if (scope?.targetScope === 'SHOP_GROUP') {
            return scope.shopGroupId === item.value;
        }
        return false;
    };

    const handleSelect = (item: NonNullable<typeof items>[number]) => {
        const { targetScope } = item;
        setIsChanging(true);
        setScope({
            targetScope,
            shopId: targetScope === 'SHOP' ? item.value : undefined,
            shopGroupId: targetScope === 'SHOP_GROUP' ? item.value : undefined,
        });
        const timeout = setTimeout(() => {
            setIsChanging(false);
        }, 400);
        return () => clearTimeout(timeout);
    };

    return { items, isSelected, handleSelect };
}

export default useSelectScope;
